import { Check, X, Truck, Upload, Eye, CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isPast, parseISO, startOfDay } from "date-fns";

type StatusView = 
  | "pending-review"
  | "awaiting-confirmation"
  | "pickup-scheduled"
  | "confirmed"
  | "picked-up"
  | "delivered"
  | "returned"
  | "archived"
  | "user-canceled";

interface StatusActionsProps {
  status: StatusView;
  pickupDate?: string; // ISO date string for checking if date has passed
  onApprove?: () => void;
  onDeny?: () => void;
  onMarkPickedUp?: () => void;
  onUploadConfirmation?: () => void;
  onViewDetails?: () => void;
  onReschedule?: () => void;
}

export const StatusActions = ({
  status,
  pickupDate,
  onApprove,
  onDeny,
  onMarkPickedUp,
  onUploadConfirmation,
  onViewDetails,
  onReschedule,
}: StatusActionsProps) => {
  // Check if pickup date has passed
  const isPickupDatePast = pickupDate ? isPast(startOfDay(parseISO(pickupDate))) && !isPast(new Date(pickupDate)) ? false : isPast(parseISO(pickupDate)) : false;
  
  switch (status) {
    case "pending-review":
      return (
        <div className="flex items-center gap-2">
          <Button size="sm" onClick={onApprove} className="bg-emerald-600 hover:bg-emerald-700">
            <Check className="h-4 w-4 mr-1" />
            Approve
          </Button>
          <Button size="sm" variant="destructive" onClick={onDeny}>
            <X className="h-4 w-4 mr-1" />
            Deny
          </Button>
        </div>
      );

    case "pickup-scheduled":
      // Show reschedule option if pickup date has passed
      if (isPickupDatePast && onReschedule) {
        return (
          <div className="flex items-center gap-2">
            <Button size="sm" variant="outline" onClick={onReschedule} className="text-amber-600 border-amber-300 hover:bg-amber-50">
              <CalendarClock className="h-4 w-4 mr-1" />
              Reschedule
            </Button>
            <Button size="sm" onClick={onMarkPickedUp}>
              <Truck className="h-4 w-4 mr-1" />
              Mark Picked Up
            </Button>
          </div>
        );
      }
      return (
        <Button size="sm" onClick={onMarkPickedUp}>
          <Truck className="h-4 w-4 mr-1" />
          Mark as Picked Up
        </Button>
      );

    case "picked-up":
      return (
        <Button size="sm" onClick={onUploadConfirmation}>
          <Upload className="h-4 w-4 mr-1" />
          Upload Delivery Confirmation
        </Button>
      );

    case "delivered":
    case "archived":
    case "user-canceled":
      return null;

    default:
      return null;
  }
};
